import { createContext, useEffect, useState } from "react";

import { useNavigate } from "react-router-dom";
import axios from "axios";

export const PitchContext = createContext();

const PitchContextProvider = ({ children }) => {
  const [pitches, setPitches] = useState([]);
  const [pendingBookingID, setPendingBookingID] = useState();
  const [userNote, setUserNote] = useState("");
  const [city, setCity] = useState("");
  const [district, setDistrict] = useState("");
  const [isPaid, setIsPaid] = useState(false);
  const [isErr, setIsErr] = useState(false);
  const [search, setSearch] = useState("");
  const [token, setToken] = useState(() => {
    const storedToken = localStorage.getItem("token");
    return storedToken ? storedToken : null;
  });
  const [pending, setPending] = useState(false);
  const [bookingData, setBookingData] = useState({});
  const [user, setUser] = useState(() => {
    const storedUser = localStorage.getItem("user");
    return storedUser ? JSON.parse(storedUser) : null;
  });
  const backendURL = "https://halisaham-git-backend.onrender.com/api/";
  const navigate = useNavigate();
  const [showAlert, setShowAlert] = useState();
  const [alertMessage, setAlertMessage] = useState();

  useEffect(() => {
    if (localStorage.getItem("user")) {
      setUser(JSON.parse(localStorage.getItem("user")));
    }
  }, [token]);

  const getAllPitches = async () => {
    try {
      setPending(true);
      const response = await axios.get(backendURL + "pitch/get");
      if (response.data.success) {
        setPitches(response.data.pitches);
        setPending(false);
      }
    } catch (err) {
      setPending(false);
      console.log(err);
    }
  };

  const getUser = async () => {
    if (user) {
      try {
        const response = await axios.post(
          backendURL + "user/get",
          { userID: user._id },
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        );

        if (response.data.success) {
          setUser(response.data.user);
        } else {
          setIsErr(true);
          setAlertMessage("Lütfen çıkış yapıp tekrar giriş yapınız.");
          setShowAlert(true);
        }
      } catch (err) {
        setIsErr(true);
        setAlertMessage("Lütfen çıkış yapıp tekrar giriş yapınız.");
        setShowAlert(true);
      }
    }
  };

  useEffect(() => {
    getAllPitches();
    getUser();
  }, [token]);

  const value = {
    token,
    setToken,
    user,
    setUser,
    pitches,
    city,
    setCity,
    district,
    getAllPitches,
    setDistrict,
    search,
    setSearch,
    bookingData,
    setBookingData,
    backendURL,
    navigate,
    pending,
    isErr,
    setIsErr,
    setPending,
    setPitches,
    getUser,
    showAlert,
    setShowAlert,
    alertMessage,
    setAlertMessage,
    pendingBookingID,
    setPendingBookingID,
    userNote,
    setUserNote,
    isPaid,
    setIsPaid,
  };

  return (
    <PitchContext.Provider value={value}>{children}</PitchContext.Provider>
  );
};

export default PitchContextProvider;
